/* Texto do resultado de POST /dispositivos/imei.

   A API devolve { encontrados, enfileirados }: os ENCONTRADOS ja existem (local
   ou no cache do Google); os ENFILEIRADOS so entraram na fila de vinculacao.
   Dizer "N IMEIs registrados" para os dois casos prometia um registro que, para
   os enfileirados, ainda nao aconteceu. */
export function resumoImeis(data: any, enviados: number): string {
  const encontrados = Number(data?.encontrados);
  const enfileirados = Number(data?.enfileirados);
  if (!Number.isFinite(encontrados) || !Number.isFinite(enfileirados))
    return enviados === 1 ? 'IMEI enviado.' : `${enviados} IMEIs enviados.`;
  const partes: string[] = [];
  if (encontrados) partes.push(`${encontrados} já cadastrado(s)`);
  if (enfileirados) partes.push(`${enfileirados} na fila de vinculação — entram quando o aparelho for localizado`);
  return partes.length ? partes.join(' · ') : 'Nenhum IMEI processado.';
}
